import React from 'react';
import {
  FDContentContainer, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMobileLayout from 'Hooks/useMobileLayout';

const Layout = () => {
  const isMobile = useMobileLayout();

  // TODO: Uncomment when we get video resources for the learn more pages.
  // const { resource } = useMetaLayoutContext();

  return (
    <FDContentContainer maxWidth={'lg'}>
      <FDStack spacing={1} direction={isMobile ? 'column' : 'row'}>
        <FDStack direction={'column'} spacing={1} flex={1}>
          <MetaControlField attr={'title'} />
          <MetaControlField attr={'subtitle'} />
        </FDStack>
        {/* <FDStack flex={2}> */}
        {/*  <AdditionalDetailVideoPicker resource={resource} /> */}
        {/* </FDStack> */}
      </FDStack>
      <MetaControlField attr={'sections'} />
    </FDContentContainer>
  );
};

export default Layout;
